import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/home/HomeView.vue"),
  },
  {
    path: "/AboutUs",
    name: "AboutUs",
    component: () => import("../views/AboutUs/AboutUs.vue"),
  },
  {
    path: "/History",
    name: "History",
    component: () => import("../views/AboutUs/History.vue"),
  },
  {
    path: "/Honor",
    name: "Honor",
    component: () => import("../views/AboutUs/Honor.vue"),
  },
  {
    path: "/WorldDuty",
    name: "WorldDuty",
    component: () => import("../views/AboutUs/WorldDuty.vue"),
  },
  {
    path: "/Arhud",
    name: "Arhud",
    component: () => import("../views/product/Arhud.vue"),
  },
  {
    path: "/Whud",
    name: "Whud",
    component: () => import("../views/product/Whud.vue"),
  },
  {
    path: "/CoolingCabinet",
    name: "CoolingCabinet",
    component: () => import("../views/product/CoolingCabinet.vue"),
  },
  {
    path: "/DualDisplays",
    name: "DualDisplays",
    component: () => import("../views/product/DualDisplays.vue"),
  },
  {
    path: "/Arhudanimated",
    name: "Arhudanimated",
    component: () => import("../views/product/animatedshow/Arhudanimated.vue"),
  },
  {
    path: "/Whudanimated",
    name: "Whudanimated",
    component: () => import("../views/product/animatedshow/Whudanimated.vue"),
  },
  {
    path: "/CoolingCabinetanimated",
    name: "CoolingCabinetanimated",
    component: () =>
      import("../views/product/animatedshow/CoolingCabinetanimated.vue"),
  },
  {
    path: "/DualDisplaysabinetanimated",
    name: "DualDisplaysabinetanimated",
    component: () =>
      import("../views/product/animatedshow/DualDisplaysabinetanimated.vue"),
  },
  {
    path: "/News",
    name: "News",
    component: () => import("../views/news/index.vue"),
  },
  {
    path: "/newsDetails",
    name: "newsDetails",
    component: () => import("../views/news/newsDetails.vue"),
  },
  {
    path: "/invite",
    name: "invite",
    component: () => import("../views/invite/index.vue"),
  },
  {
    path: "/inviteDetails",
    name: "inviteDetails",
    component: () => import("../views/invite/inviteDetails.vue"),
  },
  {
    path: "/cooperation",
    name: "cooperation",
    component: () => import("../views/cooperation/index.vue"),
  },
  {
    path: "/Contact",
    name: "Contact",
    component: () => import("../views/Contact/index.vue"),
  },
  {
    path: "/peripheralProducts",
    name: "peripheralProducts",
    component: () => import("../views/product/peripheralProducts.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    //x代表横坐标，y代表纵坐标
    return { x: 0, y: 0 };
  },
});

export default router;
